/* ==========================================================================
   Polyfill
   ========================================================================== */
import "focus-visible";
import "mdn-polyfills/Node.prototype.remove";
import "mdn-polyfills/Element.prototype.closest";
import "mdn-polyfills/String.prototype.includes";
/* See: https://github.com/msn0/mdn-polyfills/issues/57 */
import "classlist-polyfill";
import "whatwg-fetch";

/* ==========================================================================
   Vendor
   ========================================================================== */
import AOS from "aos";
import "lazysizes";
import "lazysizes/plugins/respimg/ls.respimg";
import "htmx.org";

document.documentElement.classList.remove("no-js");

window.addEventListener("load", () => {
  AOS.init({
    disable: () =>
      document.body.classList.contains("disable-animations")
        ? true
        : window.innerWidth < 1024,
    once: true,
    duration: 600,
    anchorPlacement: "top-bottom",
    offset: 40,
  });
});
